var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useService } from '@tenderd/track-web-utils';
import { message } from 'antd';
import { useEffect, useState } from 'react';
import { REFRESH_EQUIPMENT_LIST_TIMEOUT } from '../constants/Constants';
import { useGroupService } from './GroupServiceProvider';
var useGetDevices = function (props) {
    var service = useService();
    var groupService = useGroupService();
    var _a = __read(useState(false), 2), loading = _a[0], setLoading = _a[1];
    var filters = props.filters;
    var _b = __read(useState([]), 2), devices = _b[0], setDevices = _b[1];
    var _c = __read(useState(false), 2), isLiveCall = _c[0], setIsLiveCall = _c[1];
    var _d = __read(useState(0), 2), devicesTotalCount = _d[0], setDevicesTotalCount = _d[1];
    var getData = function (isLive) {
        if (isLive === void 0) { isLive = false; }
        service.server
            .getDevicesByGroups(groupService.group.id, filters === null || filters === void 0 ? void 0 : filters.query, filters === null || filters === void 0 ? void 0 : filters.statuses, filters === null || filters === void 0 ? void 0 : filters.types, (filters === null || filters === void 0 ? void 0 : filters.contractors.length) ? filters.contractors : undefined, filters === null || filters === void 0 ? void 0 : filters.radius)
            .then(function (res) {
            setIsLiveCall(isLive);
            setDevicesTotalCount(res.length);
            setDevices(res.filter(function (a) { return a.location; }));
        })
            .catch(function (err) { return message.error(err.message); })
            .finally(function () {
            setLoading(false);
        });
    };
    useEffect(function () {
        if (filters) {
            if (props.skip)
                return;
            setLoading(true);
            getData();
        }
    }, [
        filters === null || filters === void 0 ? void 0 : filters.query,
        filters === null || filters === void 0 ? void 0 : filters.statuses,
        filters === null || filters === void 0 ? void 0 : filters.types,
        filters === null || filters === void 0 ? void 0 : filters.contractors,
        filters === null || filters === void 0 ? void 0 : filters.radius,
        props.skip
    ]);
    var interval;
    useEffect(function () {
        clearInterval(interval);
        if (props.skip)
            return;
        interval = setInterval(function () {
            getData(true);
        }, REFRESH_EQUIPMENT_LIST_TIMEOUT);
        return function () {
            clearInterval(interval);
        };
    }, [filters, props.skip]);
    return { devices: devices, loading: loading, isLiveCall: isLiveCall, getData: getData, devicesTotalCount: devicesTotalCount };
};
export default useGetDevices;
